import { render, staticRenderFns } from "./TalkDashboard.vue?vue&type=template&id=ea88274e&scoped=true"
import script from "./TalkDashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkDashboard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TalkDashboard.vue?vue&type=style&index=0&id=ea88274e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea88274e",
  null
  
)

export default component.exports